import { useCiam } from '@subscriber/ciam';

import { AUTHENTICATION_STATUS } from '../enums';
import { mapCiamUserFields } from '../utils';

export const useAuthentication = () => {
  const {
    authenticationStatus: ciamAuthStatus,
    userInfo: ciamUserInfo,
    getUserInfo: getUserInfoCiam,
    redirectToSignOut: redirectToSignOutCiam,
  } = useCiam();

  function getUserInfo() {
    if (['BE', 'DL', 'LUX'].includes(MH_GROUP)) {
      return getUserInfoCiam().then(idToken =>
        idToken ? mapCiamUserFields(idToken) : null,
      );
    }

    return Promise.reject();
  }

  function redirectToSignOut(redirectUrl) {
    if (['BE', 'DL', 'LUX'].includes(MH_GROUP)) {
      redirectToSignOutCiam({
        returnTo: redirectUrl,
      });
    }
  }

  function resolveAuthenticationStatus() {
    if (['BE', 'DL', 'LUX'].includes(MH_GROUP)) {
      return ciamAuthStatus;
    }

    return AUTHENTICATION_STATUS.UNKNOWN;
  }

  function resolveUserInfo() {
    if (['BE', 'DL', 'LUX'].includes(MH_GROUP)) {
      if (ciamUserInfo) {
        return mapCiamUserFields(ciamUserInfo);
      }
    }

    return null;
  }

  return {
    authenticationStatus: resolveAuthenticationStatus(),
    ciamToken: ciamUserInfo?.tokens.id || undefined,
    userInfo: resolveUserInfo(),
    getUserInfo,
    redirectToSignOut,
  };
};
